import { AxiosResponse } from 'axios';
import { dataStores } from 'core-roblox-utilities';
import {
  TGetProductInfo,
  TGetPlayabilityStatus,
  TGetProductDetails
} from '../types/playButtonTypes';

const { gamesDataStore } = dataStores;

const getProductDetails = async (placeId: number[]): Promise<TGetProductDetails> => {
  const { data = [] } = ((await gamesDataStore.getPlaceDetails(
    placeId
  )) as unknown) as AxiosResponse<TGetProductDetails[]>;
  return data[0];
};

const getProductInfo = async (universeIds: number[]): Promise<TGetProductInfo> => {
  const {
    data: { data = [] }
  } = ((await gamesDataStore.getProductInfo(universeIds)) as unknown) as AxiosResponse<{
    data: TGetProductInfo[];
  }>;
  return data[0];
};

const getPlayabilityStatus = async (universeIds: number[]): Promise<TGetPlayabilityStatus> => {
  const { data = [] } = ((await gamesDataStore.getPlayabilityStatus(
    universeIds
  )) as unknown) as AxiosResponse<TGetPlayabilityStatus[]>;

  return data[0];
};

export default {
  getProductInfo,
  getProductDetails,
  getPlayabilityStatus
};
